export enum SkeletonListRowSize {
  Header = `header`,
  Large = `large`,
  Medium = `medium`,
  Small = `small`,
}
